import AlgebraLatex from "algebra-latex";
const DEV = false; // toggle logging
const log = (...args) => {
  if (DEV) {
    console.log(...args);
  }
};

const numbers = [];
for (let i = 0; i < 10; i++) numbers.push(i.toString());
const isNumber = (string) => {
  return numbers.indexOf(string) !== -1;
};

const getLastElement = (expression) =>
  expression[expression.length - 1] === ")"
    ? getLastElement(expression.substring(0, expression.length - 1))
    : [expression[expression.length - 1], expression.length - 1];

export function algebraToLatex(mathInput) {
  try {
    log("RECEIVED", mathInput);

    // const integral = new AlgebraLatex().parseMath("\\\\int dx").toLatex();
    // console.log(integral); // outputs: \int dx
    const algebraObj = new AlgebraLatex().parseMath(mathInput);
    log("parsed:", algebraObj.toMath()); // output: 1/sqrt(2)*x=10
    const latex = algebraObj.toLatex();
    return latex
      .replaceAll("int\\cdot", "int")
      .replaceAll("d\\cdotx", "dx")
      .replaceAll("int", "\\int")
      .replaceAll("\\cdot", (e, i, string) => {
        if (i === 0) return "";
        // console.log("test", isNumber(string[i-1]), isNumber(string[i+6]), string[i-1], string[i + 6], e,string);
        if (isNumber(string[i - 1]) && isNumber(string[i + 6])) return e;
        return "";
      }); // \frac{1}{\sqrt{2}}\cdot x=10
  } catch (err) {
    console.error(err);
    const [lastEl, lastElIndex] = getLastElement(mathInput);
    if (lastEl !== "0") {
      log("adding 0 after", lastEl, mathInput[lastElIndex]);

      return algebraToLatex(
        mathInput.substring(0, lastElIndex + 1) +
          "0" +
          mathInput.substring(lastElIndex + 1)
      );
    }
    return "ERR";
  }
}

export function findAllIndexes(str, searchStr) {
  let indices = [];
  let removedChars = 0;
  log("searching", searchStr, "in", str);

  while (str.indexOf(searchStr) !== -1) {
    const i = str.indexOf(searchStr);
    log(
      "found match at",
      i,
      str[i],
      "in",
      str,
      "adding index",
      removedChars + i
    );
    indices.push(i + removedChars);
    removedChars += str.substring(0, i + searchStr.length).length;
    str = str.substring(i + searchStr.length);
  }

  return indices;
}

export function toMathSymbols(equation, keywords, replacements) {
  let expression = equation;
  keywords.forEach((key, keyIndex) => {
    const keyphraseStartIndexes = findAllIndexes(expression, key);
    // log("OCC", keyphraseStartIndexes, "og", expression);

    // keyphraseStartIndexes.filter((i) => expression[i + 1] !== "(");
    let offset = 0;
    log(keyphraseStartIndexes.map((e) => expression[e]));
    keyphraseStartIndexes.forEach((keyphraseStart) => {
      log("found", key, "starting", expression[keyphraseStart + offset]);
      // const keyphraseStart = expression.indexOf(key);
      keyphraseStart += offset;
      const i = keyphraseStart + key.length; // index of the next character, right after the keyword
      log("O", offset);
      if (expression[i] !== "(") {
        log("putting parenthesis around", expression[i]);
        // if there are no parenthesis
        let replacement = replacements[keyIndex];
        if (replacement[0] === "(") {
          expression =
            expression.substring(0, keyphraseStart) +
            replacement.substring(0, replacement.length - 1) +
            "(" +
            expression[i] +
            "))" +
            expression.substring(i + 1);
        } else {
          expression =
            expression.substring(0, keyphraseStart) +
            replacement +
            "(" +
            expression[i] +
            ")" +
            expression.substring(i + 1);
        }
      } else {
        let replacement = replacements[keyIndex];
        let endOfElement = expression.indexOf(")", i);
        if (replacement[0] === "(") {
          expression =
            expression.substring(0, keyphraseStart) +
            replacement.substring(0, replacement.length - 1) +
            "(" +
            expression.substring(i, endOfElement + 1) +
            ")" +
            replacement[replacement.length - 1] +
            expression.substring(endOfElement + 1);
        } else {
          expression =
            expression.substring(0, keyphraseStart) +
            replacements[keyIndex] +
            expression.substring(i);
        }
      }
      offset += expression.length - equation.length;
      log("new expression");
      log(expression);
      log(equation);

      equation = expression;
      // all 1 minus tangent Theta then over all one plus Tangent Theta then D Theta.
    });
  });
  return expression;
}
function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}
export const getElement = (equ, i) => {
  if (equ[i] !== "(") {
    if (equ.substring(i, i + 2) === "pi") {
      return "pi";
    }
    if (isNumeric(equ[i])) {
      let result = "";
      let j = i;
      while (isNumeric(equ[j])) {
        result += equ[j];
        j++;
      }
      return equ.substring(j, j + 2) === "pi" ? result + "pi" : result;
    }
    return equ[i];
  }
  try {
    return equ.substring(i + 1, equ.getIndexOf(")", i + 1));
  } catch (err) {
    return "";
  }
};
export const getOccurences = (arr, target) => {
  return arr.reduce(
    (total, val) => (val.toString().indexOf(target) !== -1 ? total + 1 : total),
    0
  );
};

export const equalizeParenthesis = (words) => {
  let opening = getOccurences(words, "(");
  let closing = getOccurences(words, ")");
  while (closing < opening) {
    words.push(")");
    closing++;
  }
  while (opening < closing) {
    words.unshift("(");
    opening++;
  }
  return words;
};

export function splitInlineLatex(input) {
  const text = [];
  const expressions = [];
  const afterArr = [];

  // Regular expression to match pairs of $ and text in between
  const regex = /\$(.*?)\$/g;

  let match = regex.exec(input);
  let prevEnd = 0;

  while (match !== null) {
    const [fullMatch, betweenText] = match;
    const start = match.index;
    const end = regex.lastIndex - fullMatch.length;

    // Add text before the $ pair to the "before" array
    text.push(input.slice(prevEnd, start));

    // Add the text between the $ pair to the "between" array
    expressions.push(betweenText);

    // Add text after the $ pair to the "after" array
    afterArr.push(input.slice(end, regex.lastIndex));

    prevEnd = regex.lastIndex;
    match = regex.exec(input);
  }

  // Add any remaining text after the last $ pair to the "before" array
  text.push(input.slice(prevEnd));

  return [text, expressions];
}

export function joinLatexBlocks(lines) {
  let result = [];
  let blockStarted = false;
  let blockLines = [];

  for (let line of lines) {
    if (
      line.startsWith("\\begin") ||
      line.startsWith("\\$$begin") ||
      line.startsWith("\\$begin") ||
      blockStarted
    ) {
      blockLines.push(line);
      blockStarted = true;
    }

    if (line.startsWith("\\end")) {
      if (blockLines.indexOf(line) === -1) blockLines.push(line);
      result.push(blockLines.join("\n"));
      blockStarted = false;
      blockLines = [];
    } else if (!blockStarted && !line.startsWith("\\begin")) {
      result.push(line);
    }
  }
  return result;
}

// export function toLatex(equation) {
//   if (equation.length <= 1) return equation;
//   if (equation.indexOf("=") === -1) return parseSide(equation);
//   const sides = equation.split("=");
//   const leftSide = parseSide(sides[0]);
//   const rightSide = parseSide(sides[1]);
//   return `${leftSide}=${rightSide}`;
// }

// function parseSide(side = null) {
//   if (!side) return "";
//   const terms = side.split("+").map((t) => t.trim());
//   const parsedTerms = terms.map(parseTerm);
//   return parsedTerms.join("+");
// }
// function parseTerm(term) {
//   const [coefficient, variable] = term.split(/(?=[a-z])/i);
//   log("converting", coefficient, variable);
//   if (coefficient.includes("/")) {
//     const [numerator, denominator] = coefficient.split("/");
//     return `\\frac{${parseSide(numerator)}}{${parseSide(
//       denominator
//     )}} ${parseSide(variable)}`;
//   }
//   if (variable) {
//     const exponent = variable.indexOf("^") !== -1 ? variable.slice(2) : null;
//     log("variable found", exponent);
//     if (exponent) {
//       return `${coefficient}\\{${variable[0]}}^{${exponent}}`;
//     } else {
//       return `${coefficient}\\${variable}`;
//     }
//   } else {
//     return `${parseSide(coefficient)}`;
//   }
// }
